import * as typeS from "../service/types";
import Swal from 'sweetalert2'
import { ListClient } from "../service/ApiConfig";

export const listClientRequest = () => {
    return {
      type: typeS.LIST_CLIENT_REQUEST,
    };
  };
  
  export const listClientSuccess = (list) => {
    return {
      type: typeS.LIST_CLIENT_SUCCESS,
      payload: list,
    };
  };
  
  export const listClientError = (error) => {
    return {
      type: typeS.LIST_CLIENT_ERROR,
      payload: error,
    };
  };
  
  export const listClientData = () => {
    return (dispatch) => {
      try {
        ListClient().then((res) => {
          if (res && res.status === 200) {
            dispatch(listClientSuccess(res?.data?.data));
          } else {
            dispatch(listClientError("err.message"));
          }
        }).catch((err) => {
          dispatch(listClientError(err.message));
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err,
          })
        });
      } catch (err) {
        // console.log(err);
      }
    };
  }
  